<template>
  <div class="query-history">
    <Dialog v-model="showSql" title="查看SQL" size="mini">
      <div
        style="  overflow: auto;
  overflow-wrap: break-word;"
      >
        {{ taskSql }}
      </div>
    </Dialog>
    <Form ref="form" layout="inline" class="c-header-cnt">
      <FormItem label="提交时间">
        <Datepicker
          style="width:130px;"
          size="small"
          v-model="ss"
          clearable
          placeholder="开始日期"
          :maxDate="se"
        />
        -
        <Datepicker
          style="width:130px;"
          size="small"
          v-model="se"
          clearable
          placeholder="结束日期"
          :minDate="ss"
        />
      </FormItem>
      <FormItem label="结束时间">
        <Datepicker
          style="width:130px;"
          size="small"
          v-model="es"
          clearable
          placeholder="开始日期"
          :maxDate="ee"
          :minDate="ss"
        />
        -
        <Datepicker
          style="width:130px;"
          size="small"
          v-model="ee"
          clearable
          placeholder="结束日期"
          :minDate="es"
        />
      </FormItem>
      <FormItem label="状态">
        <Select
          v-model="taskStatus"
          size="small"
          clearable
          style="width:90px;margin-right: 10px"
        >
          <Option
            v-for="(value, key) in taskStatusMapSelect"
            :key="value"
            :value="key"
            >{{ value }}</Option
          >
        </Select>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="search">
          <Icon class="ion-ios-search" />搜索</Button
        >
      </FormItem>
    </Form>
    <div class="split-box">
      <Split
        v-if="showSplit"
        @$changed="setListHeight"
        mode="vertical"
        :lastSize.sync="size"
        :class="{ closed: size === '0px' }"
        :min="10"
      >
        <template slot="first">
          <!-- <div class="panel history-box" ref="listBox" :style="{'height':listTableHeight}"> -->
          <Table
            :data="data"
            :fixHeader="listTableHeight"
            ref="table"
            checkType="none"
            :resizable="true"
            :loading="loading"
            :minColWidth="106"
            @$changed:selectedKeys="onSelectedKeysChanged"
            rowSelectable
            :rowKey="rowKey"
            :sort="sort"
            @$change:sort="_onSort"
          >
            <TableColumn sortable title="QueryID" key="TaskId" :minWidth="106">
              <template slot-scope="item">
                <TableTooltip
                  :content="item.TaskId"
                  :canCopy="true"
                  :contentLength="8"
                ></TableTooltip>
              </template>
            </TableColumn>
            <TableColumn sortable title="提交时间" key="CreateTime">
              <span slot-scope="item" v-if="item.CreateTime">{{
                item.CreateTime | datefmt("YYYY-MM-DD HH:mm:ss")
              }}</span>
              <span v-else>-</span>
            </TableColumn>
            <TableColumn sortable title="开始时间" key="StartTime">
              <span slot-scope="item" v-if="item.StartTime">{{
                item.StartTime | datefmt("YYYY-MM-DD HH:mm:ss")
              }}</span>
              <span v-else>-</span>
            </TableColumn>
            <TableColumn sortable title="运行时长" key="timeDiff">
              <span slot-scope="item" v-if="item.EndTime">{{
                item | timeDiff()
              }}</span>
              <span v-else>-</span>
            </TableColumn>
            <TableColumn sortable title="查询状态" key="TaskStatus">
              <template slot-scope="item">
                <div @mouseover="mouseOverTable(item)">
                  <Tooltip :showArrow="false" position="right">
                    <span :class="taskStatusColor[item.TaskStatus]">{{
                      taskStatusMap[item.TaskStatus]
                    }}</span>
                    <template
                      v-if="item.TaskStatus === 'FAILED' && item.ErrorMessage"
                      slot="content"
                    >
                      <div>
                        {{ item.ErrorMessage }}
                      </div>
                    </template>
                    <template
                      v-if="item.TaskStatus === 'RUNNING'"
                      slot="content"
                    >
                      <div v-if="item.text">
                        {{ item.text }}
                      </div>
                      <div v-else>
                        <span
                          >速度：{{
                            (item.ProcessRows && item.QueryTime
                              ? (
                                  (item.ProcessRows * 1000) /
                                  item.QueryTime
                                ).toFixed(3)
                              : 0) + " 行/秒"
                          }}</span
                        ><br />
                        <span>扫描行数：{{ item.ProcessRows || 0 }}</span
                        ><br />
                        <span
                          >扫描数据量：{{
                            item.ProccessBytes
                              ? (
                                  item.ProccessBytes /
                                  1000 /
                                  1000 /
                                  1000
                                ).toFixed(3) + " GB"
                              : "-"
                          }}</span
                        ><br />
                      </div>
                    </template>
                  </Tooltip>
                </div>
              </template>
            </TableColumn>
            <TableColumn
              title="查询结果"
              minWidth="130"
              key="g"
              :rowCheckable="false"
              ignore
            >
              <template slot="template" slot-scope="data">
                <a
                  :class="{
                    'c-disable-color':
                      !(
                        $moment(data.Expiration).diff(
                          $moment(data.StartTime),
                          'days'
                        ) <= 30
                      ) ||
                      data.TaskStatus === 'CANCELED' ||
                      data.TaskStatus === 'FAILED'
                  }"
                  ><span class="c-mgr-10" @click="queryResult(data)"
                    >查看结果</span
                  ></a
                >
                <a
                  :class="{
                    'c-disable-color': !(
                      data.DownloadUrl && data.TaskStatus === 'FINISHED'
                    )
                  }"
                  ><span @click.stop="downloadResult(data)">下载结果</span></a
                >
              </template>
            </TableColumn>
            <TableColumn sortable title="扫描数据量" key="ProccessBytes">
              <template slot-scope="data">
                <span v-if="data.TaskStatus != 'FAILED'">{{
                  data.ProccessBytes
                    ? (data.ProccessBytes / 1000 / 1000 / 1000).toFixed(3) +
                      " GB"
                    : "-"
                }}</span>
                <span v-else>-</span>
              </template>
            </TableColumn>
            <TableColumn title="操作" key="op" minWidth="130" ignore>
              <template slot="template" slot-scope="data">
                <span
                  @click.stop
                  class="c-disable-color"
                  v-if="
                    data.TaskStatus != 'QUEUING' && data.TaskStatus != 'RUNNING'
                  "
                  >终止任务</span
                >
                <a v-else><span @click.stop="kill(data)">终止任务</span></a>
              </template>
            </TableColumn>
          </Table>
          <Pagination
            class="c-center c-m-tb-15"
            :total="pageInfo.total"
            :limit.sync="pageInfo.limit"
            :current.sync="pageInfo.pageNum"
            :limits="pageInfo.limits"
            ref="__test"
            @change="fetch"
          />
          <!-- </div> -->
        </template>
        <template slot="last">
          <!-- <div style="height:1px;background:#f5f5f5;    width: 100%;"></div> -->
          <div
            ref="resultPanel"
            style="
    overflow: hidden;
"
          >
            <Tabs
              v-model="currentTab"
              style="height:45px;line-height:45px;    margin-top: -6px;"
            >
              <Tab value="sql">查看sql</Tab>
              <Tab value="result">运行结果</Tab>
            </Tabs>
            <div
              style="position: absolute;top: 0;right: 0; height:45px;line-height:45px; margin-top: -6px;"
            >
              <Button
                type="none"
                icon
                class="close cus-btn"
                @click="close"
                style="cursor:pointer;"
              >
                <Icon class="ion-ios-close-empty" size="30" />
              </Button>
              <Button
                type="none"
                icon
                class="close cus-btn"
                @click="downloadResult"
                style="cursor:pointer"
                v-if="currentTab === 'result'"
              >
                <Icon class="ion-ios-cloud-download-outline" size="26" />
              </Button>
            </div>
            <div
              v-show="currentTab === 'sql'"
              style="padding:20px;"
              :style="{ height: lastBoxHeight + 'px' }"
            >
              <!-- <TableTooltip
                :style="{ height: lastBoxHeight + 'px' }"
                :content="taskSql"
                :canCopy="true"
                :contentLength="50"
                :tipPosition="{ my: 'left bottom-10', at: 'left top' }"
              > -->
              <Code
                height="100%"
                readonly
                :options="codeOptions"
                v-model="taskSql"
                language="sql"
                theme="vs-dark"
              />
              <!-- </TableTooltip> -->
            </div>
            <Spin overlay v-if="taskResult.loadingResult" />
            <!-- <cu-loading v-if="taskResult.loadingResult"></cu-loading> -->
            <div :style="resultBoxStyle" v-if="currentTab === 'result'">
              <DynTable
                v-if="!taskResult.loadingResult"
                ref="resTable"
                :fixHeight="tableHeight - 35"
                :scheme="taskResult.head"
                :data="taskResult.data"
              ></DynTable>
            </div>
          </div>
        </template>
        <template slot="drag">
          <Icon class="ion-drag" style="height:20px;" />
        </template>
      </Split>
    </div>
  </div>
</template>
<script>
import DynTable from '@/components/dyn-table.vue';
// import Affix from 'kpc/components/affix';
import Spin from 'kpc/components/spin';
// import Tip from 'kpc-vue/components/tip';
import Datepicker from 'kpc/components/datepicker';
import { Table, TableColumn } from 'kpc/components/table';
import Split from 'kpc/components/split';
import { Pagination } from 'kpc/components/pagination';
import { Tabs, Tab } from 'kpc/components/tabs';
import { Form, FormItem } from 'kpc/components/form';
import Button from 'kpc/components/button';
import Icon from 'kpc/components/icon';
import {
  requestTaskList,
  requestTempResult,
  requestCancelTask
} from '@/apis/query-history';
import { requestCheckTaskStatus } from '@/apis/data-query';
import Code from 'kpc/components/code';

import Dialog from 'kpc/components/dialog';

import { TASK_STATUS, TASK_STATUS_CLASS, CODE_OPTION } from '@/apis/common';
import Tooltip from 'kpc/components/tooltip';

import { Select, Option } from 'kpc/components/select';
import TableTooltip from '@/components/table-tooltip.vue';
import moment from 'moment';
function getDiff(row) {
  let diff = moment(row.EndTime).diff(moment(row.StartTime), 'seconds');
  return diff;
}
const originHeight = '350px';
export default {
  components: {
    // CuLoading,
    Tooltip,
    TableTooltip,
    Code,
    // Tip,
    Split,
    Table,
    TableColumn,
    Pagination,
    Datepicker,
    Form,
    FormItem,
    Dialog,
    Tabs,
    Tab,
    Button,
    Spin,
    Icon,
    DynTable,
    // Affix,
    Select,
    Option
  },
  filters: {
    timeDiff(row) {
      let diff = getDiff(row);
      return diff ? diff + 's' : 1 + 's';
    }
  },
  data() {
    return {
      codeOptions: CODE_OPTION,
      currentTab: 'sql',
      isQueryResult: false,
      isCheckSql: true,
      // 提交开始时间结束时间，结束时间 开始 结束时间
      ss: null,
      se: null,
      es: null,
      ee: null,
      resultTimer: 0,
      taskStatus: null,
      size: '0px',
      all: [],
      showSplit: true,
      // tab: 'detail',
      taskStatusMap: TASK_STATUS,
      taskStatusColor: TASK_STATUS_CLASS,
      currentTask: '',
      taskSql: '',
      showSql: false,
      loading: false,
      pageInfo: {
        limit: 10,
        limits: [10, 20, 50, 100]
      },
      resultPageInfo: {
        current: 1,
        limit: 100,
        isEnd: false
      },

      taskResult: {
        head: [],
        loadingResult: false,
        data: []
      },
      data: [],
      listTableHeight: 750,
      lastBoxHeight: 350,
      sort: {}
    };
  },
  created() {
    this.fetch();
    this.$EventBus.$on('REGION_CHANGED', this.updateRegion);
  },
  watch: {
    currentTask() {
      this.resultPageInfo.current = 1;
      this.resultPageInfo.isEnd = false;
      this.taskSql = this.currentTask.SQL;
      // 清空原来的结果数据
      this.taskResult.head = [];
      this.taskResult.data = [];
      this.fetchResult();
    },
    currentTab(n) {
      let row = this.$refs.table.getSelectedData()[0];
      if (n === 'result') {
        this.taskResult.head = [];
        this.taskResult.data = [];
        if (row && row.TaskId) {
          this.open(row);
        }
      }
      // console.log(row, 'row')
    },
    size(n, o) {
      if (n != '0px' && o === '0px') {
        document.querySelector('.k-line-wrapper').style.borderTop =
          '1px solid #EFEFEF';
      } else if (n === '0px') {
        document.querySelector('.k-line-wrapper').style.borderTop = '';
      }
    }
  },
  mounted() {
    // this.size = '0px';
    console.log(this.listTableHeight);
    this.$nextTick(() => {
      this.size = '0px';
      this.setListHeight();
    });
  },
  destroyed() {
    this.$EventBus.$off('REGION_CHANGED', this.updateRegion);
    clearInterval(this.resultTimer);
  },

  computed: {
    taskStatusMapSelect() {
      let newMap = JSON.parse(JSON.stringify(TASK_STATUS));
      delete newMap.ACCEPT;
      delete newMap.SUBMITTED;
      return newMap;
    },
    // listTableHeight() {
    //   let searchBarHeight = 80
    //   console.log(this.$refs.listBox, this.size !== '0px');
    //   let box = document.querySelector('.k-first')
    //   if (box) {
    //     return parseInt(box.clientHeight) - searchBarHeight;
    //   } else {
    //     return 750;
    //   }
    // },
    resultBoxStyle() {
      if (this.size !== '0px' && this.$refs.resultPanel) {
        let box =
          window.getComputedStyle(this.$refs.resultPanel.parentNode) || {};

        let containerHeight =
          parseInt(
            box.height
            // window.getComputedStyle(document.querySelector(".k-last")).height
          ) || 300;
        let height = this.size === originHeight ? 300 : containerHeight - 50;
        return {
          height: height + 'px',
          width: box.width,
          'overflow-x': 'auto',
          'overflow-y': 'hidden'
        };
      } else {
        let box =
          window.getComputedStyle(this.$refs.resultPanel.parentNode) || {};
        return {
          height: 305 + 'px',
          width: box.width,
          'overflow-y': 'hidden',
          'overflow-x': 'auto'
        };
      }
    },
    tableHeight() {
      return parseInt(this.resultBoxStyle.height);
    }
  },
  methods: {
    async updateRegion() {
      this.close();
      this.fetch();
      clearInterval(this.resultTimer);
    },
    _onSort(c, sort) {
      console.log(sort);
      const data = this.data.slice(0);
      data.sort((a, b) => {
        let result = 0;
        switch (sort.key) {
          case 'timeDiff':
            if (sort.type === 'desc') {
              result = getDiff(a) > getDiff(b) ? -1 : 1;
            } else {
              result = getDiff(a) > getDiff(b) ? 1 : -1;
            }
            break;
          default:
            if (sort.type === 'desc') {
              result = a[sort.key] > b[sort.key] ? -1 : 1;
            } else {
              result = a[sort.key] > b[sort.key] ? 1 : -1;
            }
            break;
        }
        return result;
      });
      this.data = data;
      this.sort = sort;
    },
    setListHeight() {
      let searchBarHeight = 80;
      let marginBottom = 15;
      let lastBoxHeader = 40;
      let box = document.querySelector('.k-first');
      let lastBox = document.querySelector('.k-last');
      let splitBox = document.querySelector('.split-box');
      // 底部lastBox的高度
      if (lastBox) {
        setTimeout(() => {
          let style = window.getComputedStyle(lastBox);
          this.lastBoxHeight = parseInt(style.height) - lastBoxHeader;
        }, 20);
      }
      if (box) {
        setTimeout(() => {
          let style = window.getComputedStyle(box);
          this.listTableHeight =
            parseInt(style.height) - searchBarHeight - marginBottom;
        }, 20);
        return;
      }

      if (splitBox) {
        setTimeout(() => {
          let style = window.getComputedStyle(splitBox);
          this.listTableHeight = parseInt(style.height) - searchBarHeight;
        }, 20);
        return;
      }
    },
    async mouseOverTable(item) {
      // || item.status !== 'RUNNING'
      if (!item.TaskId || item.TaskStatus !== 'RUNNING') {
        return;
      }
      item.text = '进度加载中...';
      try {
        let res = await requestCheckTaskStatus({
          TaskId: item.TaskId
        });
        item.TaskStatus = res.data.Total.Status;
        // 查询行数
        item.ProcessRows = res.data.Total.ProcessRows;
        // 扫描数据量
        item.ProcessBytes = res.data.Total.ProcessBytes;
        // 完成百分比
        item.TaskPercent = res.data.Total.TaskPercent;
        // 查询时间
        item.QueryTime = res.data.Total.QueryTime;
        item.text = '';
      } catch (error) {
        item.text = '进度加载出现错误';
        // this.Message.error(`${error.msg}`);
      }
    },
    rowKey(t) {
      return t.TaskId;
    },
    search() {
      // this.fetch();
      this.data = [];
      this.pageInfo.total = 0;
      if (this.pageInfo.pageNum === 1) {
        this.fetch({
          current: this.pageInfo.pageNum,
          limit: this.pageInfo.limit
        });
      } else {
        this.pageInfo.pageNum = 1;
      }
    },
    onSelectedKeysChanged(table) {
      console.log('onSelectedKeysChanged');
      if (!this.isQueryResult) {
        this.currentTab = 'sql';
      } else {
        this.currentTab = 'result';
        this.isQueryResult = false;
      }
      this.taskSql =
        table.getSelectedData()[0] && table.getSelectedData()[0].SQL;
      this.isCheckSql = true;
      if (this.size === '0px' && this.taskSql) {
        this.size = originHeight;
      }
      if (!this.taskSql) {
        this.size = '0px';
      }
    },
    async fetch({ current = 1, limit = 10 } = {}) {
      let params = {
        PageSize: limit,
        CurrentPage: current,
        SubmitGe: this.ss ? this.ss + ' 00:00:00' : null,
        SubmitLe: this.se ? this.se + ' 23:59:59' : null,
        FinishGe: this.es ? this.es + ' 00:00:00' : null,
        FinishLe: this.ee ? this.ee + ' 23:59:59' : null,
        Status: this.taskStatus || null
      };
      this.showLoading();
      try {
        let res = await requestTaskList(params);
        this.data = res.data.Data;
        if (res.data.Total) {
          this.pageInfo.total = res.data.Total.TotalRecords;
          this.pageInfo.pageNum = res.data.Total.CurrentPage;
          this.pageInfo.pageSize = res.data.Total.PageSize;
        }
      } catch (error) {
        this.Message['error'](` ${error.msg}`);
      }
      this.hideLoading();
    },
    async fetchResult() {
      // fix 一次获取所有结果，不再下拉加载
      if (this.resultPageInfo.current > 1) {
        return;
      }
      this.taskResult.loadingResult = true;
      try {
        let res = await requestTempResult({
          TaskId: this.currentTask.TaskId,
          CurrentPage: this.resultPageInfo.current
        });
        if (!this.taskResult.head.length) {
          this.taskResult.head = res.data.Total.Schema || [];
        }
        this.taskResult.data = res.data.Data || [];
        this.taskResult.loadingResult = false;
        if (!res.data.Data.length || res.data.Data.length < 100) {
          this.resultPageInfo.isEnd = true;
        } else {
          this.resultPageInfo.current++;
        }
      } catch (error) {
        console.log(error);
        this.Message['error'](` ${error.msg}`);
        this.taskResult.loadingResult = false;
      }
    },
    makeResult() {
      if (this.resultTimer) {
        clearInterval(this.resultTimer);
      }
      this.taskResult.loadingResult = true;
      this.resultTimer = setInterval(() => {
        this.taskResult.data = this.taskResult.data.concat(
          this.all.slice(0, 10)
        );
        this.all = this.all.slice(10);
        if (!this.all.length) {
          this.taskResult.loadingResult = false;
          clearInterval(this.resultTimer);
        }
      }, 200);
    },
    scrollEvent(e) {
      if (this.resultPageInfo.isEnd) {
        return;
      }
      let element = e.target;
      let toBottom =
        element.scrollHeight -
        element.scrollTop -
        parseInt(this.resultBoxStyle.height);
      if (
        toBottom < 50 &&
        !this.resultPageInfo.isEnd &&
        !this.taskResult.loadingResult
      ) {
        this.fetchResult();
      }
    },
    open(row) {
      if (!row.TaskId) {
        this.Message['error']('没有任务id');
        return;
      }
      if (
        !(
          this.$moment(row.Expiration).diff(
            this.$moment(row.StartTime),
            'days'
          ) <= 30
        )
      ) {
        return;
      }
      if (row.TaskStatus === 'CANCELED') {
        return;
      }
      if (this.size === '0px') {
        this.size = originHeight;
        // this.setListHeight()
      }
      this.currentTab = 'result';
      // 没有查询到数据时，重新获取下数据
      if (
        this.currentTask &&
        this.currentTask.TaskId === row.TaskId &&
        (!this.taskResult.head.length || !this.taskResult.data.length)
      ) {
        console.log('re fetch');
        this.fetchResult();
      } else {
        this.currentTask = row;
      }
      this.isCheckSql = false;
      console.log('open,', row);
    },
    queryResult() {
      this.isQueryResult = true;
    },
    close() {
      this.size = '0px';
      // this.setListHeight()
    },
    async del(row, IsAcknowledged) {
      this.showLoading();
      try {
        let res = await requestCancelTask({
          TaskId: row.TaskId,
          IsAcknowledged: IsAcknowledged ? true : false
        });
        this.Message['success'](res.msg);
        this.fetch({
          current: this.pageInfo.pageNum,
          limit: this.pageInfo.limit
        });
      } catch (error) {
        if (error.data.Status === 201) {
          Dialog['confirm']({
            title: '您确认取消任务么？',
            content: '提示: 任务运行中，取消任务仍会收取一定费用。'
          }).then(
            () => {
              this.del(row, true);
              console.log('clicked ok button');
            },
            () => {
              console.log('clicked cancel button');
            }
          );
          // } else if (error.data.Status === 206) {
          //   this.Message['error'](` ${error.msg}`);
        } else {
          this.Message['error'](` ${error.msg}`);
        }
      }
      this.hideLoading();
    },
    downloadResult(row) {
      if (row.TaskId) {
        let url = row.DownloadUrl;
        url && row.TaskStatus === 'FINISHED' ? window.open(url) : '';
      } else {
        this.$refs.resTable.exportTable('查看结果');
      }
    },
    kill(row) {
      this.del(row);
      // this.Dialog['confirm']({
      //   title: '确认终止任务？',
      //   content: '终止任务'
      // }).then(
      //   () => {
      //   },
      //   () => {}
      // );
    },
    copySql() {
      if (!this.taskSql) {
        this.Message['error']('没有要复制的内容，请先选中任务');
        return;
      }
      let oInput = document.createElement('input');
      oInput.value = this.taskSql;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand('Copy'); // 执行浏览器复制命令
      this.Message['success']('复制成功');
      oInput.remove();
    },
    checkSql(row) {
      this.taskSql = row.SQL;
      if (!row.SQL) {
        this.Message['error']('没有要查看的内容');
        return;
      }

      this.showSql = true;
      console.log(row, this.showSql);
    }
  }
};
</script>
<style lang="stylus">
.split-box {
  height: calc(100vh - 190px);
}

.k-first {
  // border-top 1px solid #EFEFEF
}

.query-history .k-form-item .k-label {
  color: #666;
  font-size: 12px;
  // display: inline-block;
  font-weight: normal;
  margin: 0;
}

.cus-btn {
  width: 45px;
  height: 45px;
}
.query-history .k-first {
  // border-bottom: 1px solid #EFEFEF;
}
</style>
